import CreateWorkspace from "../../components/pages/CreateWorkspace";

export default function CreateWorkspaceView() {
    return (
        <>
            <CreateWorkspace/>
        </>
    );
}
